var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5986 9.97357C30.048 6.3162 25.9366 7.8587 23.3908 9.48992C21.9523 10.4116 19.9597 10.4116 18.5212 9.48992C15.9754 7.85872 11.864 6.31624 8.31352 9.97358C-0.114871 18.6556 14.3391 35.3855 20.9561 35.3855C27.573 35.3855 42.0269 18.6556 33.5986 9.97357Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.46156de9acf008c2e04ba3b9c0aef472.svg";
export { ForwardRef as ReactComponent };